import { Component, input } from '@angular/core';

@Component({
  selector: 'app-modal-body',
  host: {
    class: 'modal-body modal-body-content text-center',
    '[class.modal-body-content--with-footer]': 'hasFooter()',
    '[class.modal-body-content--spacious]': 'spacious()',
  },
  templateUrl: './modal-body.component.html',
  styleUrl: './modal-body.component.scss',
})
export class ModalBodyComponent {
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
  public readonly titleId = input.required<string>();
  public readonly descriptionId = input.required<string>();
  public readonly hasFooter = input(false);
  public readonly spacious = input(false);
}
